import React from 'react';
import { css } from 'linaria';
import { Section, SectionSubTitle, SwiperSlide, SwiperWithNavigation } from 'common/components';
import { METAL_ROOF_PARTNERS_LIST } from './metal-roof-partners-constants';

const metalRoofPartnersSlide = css`
  && {
    width: 124px;
    height: 72px;
    margin-right: 40px;

    @media (--only-mobile) {
      width: 102px;
      height: 60px;
      margin-right: 16px;
    }
  }
`;

const metalRoofPartnerImage = css`
  width: 100%;
  height: 100%;
`;

export const MetalRoofPartners = () => (
  <Section>
    <SectionSubTitle margin="m">Работаем с проверенными партнёрами</SectionSubTitle>
    <SwiperWithNavigation
      breakpoints={{
        1024: { enabled: true },
      }}
      slidesPerView="auto"
      watchOverflow>
      {METAL_ROOF_PARTNERS_LIST.map(({ alt, src }) => (
        <SwiperSlide className={metalRoofPartnersSlide}>
          <img className={metalRoofPartnerImage} alt={alt} src={src} />
        </SwiperSlide>
      ))}
    </SwiperWithNavigation>
  </Section>
);
